import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
//引入remixicon样式
import "remixicon/fonts/remixicon.css";
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react'
import App from "./App";
// import reportWebVitals from './reportWebVitals';

const API_KEY = 'phc_j1BWO0TuxPdNWoG6JUG9ZxWOwAtxdb2Da0bHruonYIk'

posthog.init(API_KEY, {
  api_host: 'https://e.cemeta.cn',
  feature_flag_request_timeout_ms: 10000
});
// console.log('env',  )
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <PostHogProvider client={posthog}>
      <App />
  </PostHogProvider>
  // </React.StrictMode>
);
